import { MerchantLogo } from '@/app/components/MerchantLogo'
import {
  Currency,
  CurrencyOption,
  isBvnkCurrency,
  isLayer1Currency,
  Protocol,
} from '@/types/currency'

export const popularCurrencies = ['BTC', 'USDT', 'LTC', 'XRP', 'ETH']

export const getNetworkByProtocol = (protocol: string | undefined): string => {
  switch (protocol) {
    case 'ERC20':
      return 'Ethereum'
    case 'TRC20':
      return 'Tron'
    case 'BEP20':
      return 'Binance'
    default:
      return 'Ethereum'
  }
}

export const mappedCurrencies = (
  currencies: Currency[] | undefined,
  currencyOptions: CurrencyOption[] | undefined
): Currency[] => {
  if (!currencies || !currencyOptions) return []

  return currencies
    ?.filter(currency => currencyOptions?.some(option => option?.code === currency?.code))
    ?.map(currency => {
      const option = currencyOptions?.find(option => option?.code === currency?.code)
      // If the option's protocols array is empty, return all protocols for the currency.
      if (option && option?.protocols?.length === 0) {
        return currency
      }
      return {
        ...currency,
        enabledProtocols: isBvnkCurrency(currency)
          ? currency?.enabledProtocols?.filter((protocol: Protocol) =>
              option?.protocols?.includes(protocol?.code)
            )
          : [],
      }
    })
    .filter(currency => {
      if (isBvnkCurrency(currency)) {
        return currency?.enabledProtocols?.length > 0
      }
    })
}

export const findLogoByMerchantId = (
  targetMerchantId: string,
  enableMerchantLogo: MerchantLogo[]
): string => {
  for (const logoMapping of enableMerchantLogo) {
    const logoValue = logoMapping?.[targetMerchantId]
    if (logoValue !== undefined) {
      return logoValue
    }
  }
  return ''
}

export const applyFilters = (
  currencies: Currency[] | undefined,
  filterCurrencyOptions: CurrencyOption[] | undefined
): Currency[] => {
  if (!currencies || !filterCurrencyOptions) return []

  return currencies
    ?.filter(currency => {
      const filterOption = filterCurrencyOptions?.find(option => option?.code === currency?.code)
      return !!filterOption
    })
    ?.map(currency => {
      const filterOption = filterCurrencyOptions?.find(option => option?.code === currency?.code)

      const filteredProtocols = isBvnkCurrency(currency)
        ? currency?.enabledProtocols?.filter((protocol: Protocol) =>
            filterOption?.protocols?.includes(protocol?.code)
          )
        : []

      return {
        ...currency,
        enabledProtocols: filteredProtocols,
      }
    })
    ?.filter(currency => {
      if (isBvnkCurrency(currency)) {
        return currency?.enabledProtocols?.length
      } else if (isLayer1Currency(currency)) {
        // For Layer1 currencies, filter by depositEnabled
        return currency.depositEnabled
      }
      return false
    })
}

export const removeFilteredCurrencies = (
  currencies: Currency[] | undefined,
  filterCurrencyOptions: CurrencyOption[] | undefined
): Currency[] => {
  if (!currencies || !filterCurrencyOptions) return currencies || []

  return currencies?.filter(currency => {
    const filterOption = filterCurrencyOptions?.find(option => option?.code === currency?.code)
    return !filterOption // Return true to keep currencies NOT found in the filter
  })
}

export const redirectToExternalUrl = (url: string) => {
  let augmentedUrl = url
  if (!/^https?:\/\//i.test(url)) {
    augmentedUrl = `https://${url}`
  }

  window.location.replace(augmentedUrl)
}
